// extracted by mini-css-extract-plugin
module.exports = {"annotatedSectionGroup":"FvWpy","annotatedSection":"rP3S5","annotation":"yQeHo","content":"IH48r","title":"DjKdV","description":"pxZRo"};